export const normalizeRequirement = (requirement) => {
  const normalized = String(requirement || '').trim().toLowerCase();

  if (!normalized || normalized === 'none' || normalized === 'free') return 'free';
  if (normalized === 'logged_in' || normalized === 'logged-in') return 'login';
  if (normalized === 'regions' || normalized === 'regional' || normalized === 'poland-regions') return 'poland_regions';
  if (normalized === 'plus' || normalized === 'polska') return 'poland';

  return normalized;
};

export const hasRequirementAccess = ({ requirement, user, hasRole, vipModeEnabled }) => {
  const normalized = normalizeRequirement(requirement);

  if (normalized === 'free') return true;
  if (normalized === 'login') return !!user;
  if (!vipModeEnabled) return true;
  if (hasRole('admin')) return true;
  if (normalized === 'poland' || normalized === 'poland_regions') {
    return hasRole('poland') || hasRole('poland_regions');
  }
  if (normalized === 'vip') {
    return hasRole('vip') || hasRole('poland') || hasRole('poland_regions');
  }

  return hasRole(normalized);
};

export const getCompetitionToolRequirement = (competition, requirementField = 'stats_requirement') => {
  if (!competition) return 'free';

  return competition[requirementField] || 'free';
};

export const getRequirementTeaserMessage = (requirement, fallback = 'Dostęp tylko dla VIP') => {
  const normalized = normalizeRequirement(requirement);

  if (normalized === 'login') return 'Zaloguj się aby zobaczyć';
  if (normalized === 'poland' || normalized === 'poland_regions') return 'Dostępne w Symuliga VIP';

  return fallback;
};
